import type { ButtonHTMLAttributes } from 'react'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode
  onClick?: () => void
  text?: string
  className?: string
  color?: 'primary' | 'secondary' | 'success'
  variant?: 'container' | 'outlined' | 'text'
  classes?: string
  size?: 'small' | 'large'
}

const StyleMapping = {
  'primary-outlined': 'text-primary border-primary border-[1px]',
  'primary-container': 'text-white border-primary bg-primary border-[1px]',
  'secondary-outlined': 'text-secondary border-secondary border-[1px]',
  'secondary-container':
    'text-white border-secondary bg-secondary border-[1px]',
  'success-outlined': 'text-success bordertext-success border-[1px]',
  'success-container':
    'text-white bordertext-success bgtext-success border-[1px]',
  'success-text': 'text-success',
  'primary-text': 'text-primary',
  'secondary-text': 'text-secondary',
}

export const Button = ({
  children,
  className,
  color = 'primary',
  variant = 'container',
  size = 'small',
  text = '',
  classes = '',
  ...props
}: ButtonProps) => (
  <button
    className={`${
      StyleMapping[`${color}-${variant}`]
    } ${className} ${classes} ${size === 'small' ? 'h-12' : 'h-[58px]'} ${
      props.disabled ? 'cursor-not-allowed opacity-[0.6]' : ''
    } flex min-w-[162px] items-center justify-center whitespace-nowrap rounded-xl px-4 text-sm font-semibold`}
    {...props}
  >
    {text || children}
  </button>
)

export default Button
